export default __webpack_public_path__ + "static/media/game-developer.a8187517.svg";